import { NAT_TYPE } from '@/pages/income/config';
import { DEVICE_NAT_INDICATOR } from '@/pages/income/config/device';
const defaultText = '--';

export const diskUnitFormat = (num) => {
  let text = '';
  if (num === undefined) {
    return defaultText;
  }

  num = Number(num);
  if (num >= 1024) {
    text = `${(num / 1024).toFixed(1)} T`;
  } else {
    text = `${num.toFixed(1)} G`;
  }

  return text;
};

export const diskUnitFormatM = (num) => {
  let text = '';
  if (num === undefined) {
    return defaultText;
  }
  if (Number(num) >= 1024) {
    text = `${(Number(num) / 1024).toFixed(1)} G`;
  } else {
    text = `${Number(num).toFixed(1)} M`;
  }
  return text;
};

export const ramNumTransform = (num) => {
  let text = '';
  if (num === undefined) {
    return defaultText;
  }

  if (num === 0) return num;

  num = Number(num);
  if (num >= 1024) {
    text = `${(num / 1024).toFixed(1)} G`;
  } else {
    text = `${num.toFixed(1)} M`;
  }

  return text;
};

export const processChartData = (chartData, type = 'online') => {
  let xData = [],
    yData = [];
  if (!chartData || chartData.length === 0) return { xData, yData };
  chartData.map((item, index) => {
    xData.push(item.time);
    if (type === 'online') {
      const itemVal = (item.value / 60).toFixed(2);
      if (index >= 18 && index <= 23) {
        const colorItem = {
          value: itemVal,
          itemStyle: {
            color: '#fb7e0c',
          },
        };
        yData.push(colorItem);
      } else {
        yData.push(itemVal);
      }
    } else if (type === DEVICE_NAT_INDICATOR || type === 'nat') {
      const itemVal = NAT_TYPE[item.value].level;
      yData.push(itemVal);
    } else {
      yData.push(item.value);
    }
  });
  const result = {
    xData,
    yData,
  };
  return result;
};

export const formatMinuteToHour = (value) => {
  let dom = defaultText;
  if (value !== undefined) {
    let num = Number(value);
    let hour = 0;
    if (num > 0) {
      hour = (num / 60).toFixed(1);
    }
    let text = `${Number(hour)}h`;
    dom = text;
  }
  return dom;
};

// 元转成分
export const getFen = (amount) => {
  let fen = 0;
  try {
    if (amount.length > 0) {
      let bd = parseFloat(amount);
      let fenBd = bd * 100;
      return Math.floor(fenBd); // Using Math.floor to mimic toInt behavior.
    }
  } catch (e) {
    console.error(e); // Using console.error for logging exceptions.
  }
  return fen;
};
